import router from './router'
import store from './store'
import { getToken } from './utils/auth' // get token from cookie

// const whiteList = ['/home','/login','/login-offline', '/auth-redirect','/login_multi'] // no redirect whitelist
const whiteList = ['/login', '/auth-redirect', '/registrasi'] // no redirect whitelist


router.beforeEach(async(to, from, next) => {
    store.dispatch('onsen/updateModalVisible', true)


    // console.log('ini cordova: '+Vue.cordova)
    // console.log('beforeFrom', from)
    // console.log('beforerouteTo', to)
    // console.log('beforerouteNext', next)
    // let parentRoute = (from.matched[0])?from.matched[0]:[]
    // let parentPath = (parentRoute.path)?parentRoute.path:''
    // console.log('from:: ', from)
    // console.log('from.Path: '+from.path)
    // await store.dispatch('utilsCordova/updateCloseApp', false)
    // if (from.path === '/') {
    //   console.log('closd App ')
    //   await store.dispatch('utilsCordova/updateCloseApp', true)
    //   // alert('redirect to')
    // }

    // console.log('parentPath:: ', parentPath)
    // console.log('toFullPath:: ', to.fullPath)
    // console.log('parentRoute:: ', parentRoute)
    if (to.meta && to.meta.title) {
        let hasBack = false
        if (to.fullPath !== '/') {
            hasBack = true
        }
        const routeInfo = { routeTitle: to.meta.title, routeHasBack: hasBack }
            // console.log('routeInfoxx', routeInfo)
        store.dispatch('permission/updateRouteTitleChildren', routeInfo)
    }

    // determine whether the user has logged in
    const hasToken = getToken()
        // console.log('to.path', to.component)
    if (hasToken) {
        if (to.path === '/login') {
            // if is logged in, redirect to the home page
            store.dispatch('onsen/updateModalVisible', false)
            next({ path: '/' })
        } else {
            // determine whether the user has obtained his permission roles through getInfo
            const hasRoles = store.getters.roles && store.getters.roles.length > 0
            if (hasRoles) {
                // console.log('hasRoles', hasRoles)
                store.dispatch('onsen/updateModalVisible', false)
                next()
            } else {
                try {
                    // get user info
                    // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
                    const {
                        roles
                    } = await store.dispatch('user/getInfo')
                        // const accessRoutes = []
                        // generate accessible routes map based on roles
                    const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
                        // console.log('accessRoutesx', accessRoutes)
                        // dynamically add accessible routes
                    router.addRoutes(accessRoutes)
                        // update title
                        // const { meta } = to
                        // console.log('toxx', to)

                    // hack method to ensure that addRoutes is complete
                    // set the replace: true, so the navigation will not leave a history record
                    store.dispatch('onsen/updateModalVisible', false)
                    next({...to, replace: true })
                        // next({ ...to, replace: false })
                } catch (error) {
                    // remove token and go to login page to re-login
                    await store.dispatch('user/resetToken')
                    store.dispatch('onsen/updateModalVisible', false)
                    next(`/login`)
                        // next(`/home?redirect=${to.path}`)
                }
            }
        }
    } else {
        /* has no token */
        if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next()
        } else {
            // other pages that do not have permission to access are redirected to the login page.
            store.dispatch('onsen/updateModalVisible', false)
                // next(`/home?redirect=${to.path}`)
            next(`/login`)
        }
    }
})

router.afterEach(() => {
    // finish progress bar
    store.dispatch('onsen/updateModalVisible', false)
})


// WEBPACK FOOTER //
// ./src/permission.js